module.exports = __webpack_public_path__ + "media/app/assets/races/gnome_female-4da9a373142167d01dbd23af3f69647d.png";